import React from 'react';

function RelatedVideo(props){
    let cardStyle = {
        transform: "translate("+props.cs+"px)",
        width : props.width-15,
        marginRight : "15px"       
    };

    let video;
    let clsNames = "card";
    let posterStyle = null;
 
    posterStyle = {
        width : props.width-15,
        height : (props.width-15) * 0.56,
        overflow : "hidden"
    }
    
    if(props.preview){
        clsNames = "card h-100";
    }

    video = <div style={cardStyle} className={clsNames}>
            <div style={posterStyle}>
            <img onClick={function(event){props.handleLoadVideo(props.vfkey, event); props.handleClickVideo(props.vfkey, event);}}  className="card-img-top poster" src={props.poster} alt="..." />
            </div>
            <div className="card-body">
                <h5 className="card-title">{props.title}</h5>
                <p className="card-text">{props.desc}</p>
            </div>
        </div>

    return (video);
}
export default RelatedVideo;


// WEBPACK FOOTER //
// ./src/components/RelatedVideo.js